// App.styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { FontWeight } from '../../assets/styles';

const pxToRem = (px: number): string => `${px / 16}rem`;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    boxShadow: 'none',
    borderRadius: '22.5px !important',
    height: pxToRem(45),
    fontSize: `${pxToRem(14)} !important`,
    fontWeight: `${FontWeight.Bold} !important`,
    width: '100%',
  },
}));

export default useStyles;
